import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Detects a `?new=1` deep-link (emitted by the global "New" quick-create menu)
 * and invokes `onOpen` exactly once, then clears the parameter from the URL so
 * a later refresh doesn't reopen the modal unexpectedly.
 *
 * `ready` lets callers defer opening until their data has loaded (e.g. to
 * auto-select the single fulfilment location before showing the modal).
 */
export function useCreateDeepLink(onOpen: () => void, ready = true): void {
  const [searchParams, setSearchParams] = useSearchParams();
  const fired = useRef(false);
  const onOpenRef = useRef(onOpen);
  onOpenRef.current = onOpen;

  useEffect(() => {
    if (fired.current || !ready || searchParams.get("new") !== "1") return;
    fired.current = true;
    onOpenRef.current();
    setSearchParams({}, { replace: true });
  }, [ready, searchParams, setSearchParams]);
}